import { type CountryCode, COUNTRY_TIMEZONE, DATE_FORMAT } from '@constants'
import { format } from 'date-fns'
import { formatInTimeZone, toZonedTime, fromZonedTime } from 'date-fns-tz'

/**
 * 美國時區統一使用西岸時區
 */
const US_TIMEZONE = 'America/Los_Angeles'

export const parseDateToApiFormat = (date?: Date | null, formatStr = DATE_FORMAT) => date && typeof date !== 'string' ? format(date, formatStr) : null
export const timestampToDate = (timestamp: number) => {
  const dateFormat = 'yyyy-MM-dd HH:mm'
  return format(new Date(timestamp * 1000), dateFormat)
}

export const dateToTimestamp = (date: Date) => {
  return new Date(date).getTime() / 1000
}

export const dateToString = (date: Date | null, formatProp?: string) => {
  if (!date) return
  const dateFormat = formatProp || 'yyyy-MM-dd'
  return format(date, dateFormat)
}

export const utcToUsTimezone = (utcDate: Date | string): Date => {
  return toZonedTime(utcDate, US_TIMEZONE)
}

export const usTimezoneToUtc = (usDate: Date): Date => {
  return fromZonedTime(usDate, US_TIMEZONE)
}

/**
 * 檢測指定日期在美國洛杉磯時區是 PST（標準時間）還是 PDT（夏令時間）
 */
export const getCurrentUsTimezoneType = (date: Date): 'PST' | 'PDT' => {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: US_TIMEZONE,
    timeZoneName: 'short',
  })

  const parts = formatter.formatToParts(date)
  const timeZoneName = parts.find(part => part.type === 'timeZoneName')?.value

  return timeZoneName as 'PST' | 'PDT'
}

export const formatDateTimeByCountryCode = (
  isoString: string | Date,
  countryCode: CountryCode,
  formatStr: string,
): string => {
  if (!isoString) return ''
  const timezone = COUNTRY_TIMEZONE[countryCode] ?? 'Asia/Taipei'
  return formatInTimeZone(new Date(isoString as string), timezone, formatStr)
}
